'use strict';

angular.module('shiftTraderApp')
    .directive('saUserRecommendBar', function () {
      return {
        templateUrl: 'views/directives/saUserRecommendBar.html',
        restrict: 'EA',
        scope: {
          shift: '=',
          weekRange: '=',
          adjustedWeekRange: '=',
          excludeWpId: '='
        },
        controller: ['$scope', 'AvailabilityService', 'ShepherdTourService', 'TimeService', '$log',
          function ($scope, AvailabilityService, ShepherdTourService, TimeService, $log) {
          $scope.state = {
            isAssignedToShift: false,
            stillCalculating: false
          };

          var wpidExclusion = null;

            // in the case where we are editing a shift in CWP, shift.id will exist
          if ($scope.shift.id && $scope.shift._type === 'workPeriod' && ($scope.excludeWpId === 'true' || $scope.excludeWpId === true)) {
            wpidExclusion = $scope.shift.id;
          }

          $scope.decodeDayOfWeek = AvailabilityService.decodeDayOfWeek;

          $scope.addUserToShift = function() {
            $scope.$emit('addUserToShift', $scope.emp);
            ShepherdTourService.triggerEvent('userRecommendAssign', 500);
          };

          $scope.unassignUserFromShift = function() {
            $scope.$emit('unassignUserFromShift')
          }

          $scope.$watch('state.isAssignedToShift', function(val) {
            console.log('WATCH: isAssignedToShift -- ' + val, $scope.emp && $scope.emp.name);
          });

          // FROM cwpEmployeeListing/smartSchedulingEmployeeListItem
          $scope.getViolationDescription = AvailabilityService.getAvailabilityViolationDescription;

          var isAssignedToShift = function() {
            return $scope.emp._workPeriods &&
                (($scope.shift._workPeriod && $scope.shift._workPeriod.user && $scope.shift._workPeriod.user.id === $scope.emp.id) ||
                    //($scope.shift.user && $scope.shift.user.id === $scope.emp.id));
                    ($scope.shift.user && $scope.shift.user.id === $scope.emp.id && $scope.shift.id !== wpidExclusion) || $scope.emp._scheduledToWork);
          };

          var wpIsSameAsShiftWp = function(wp) {
            return $scope.shift._workPeriod && $scope.shift._workPeriod.id === wp.id;
          };

          var initializeWeekCalendarData = function() {
            $scope.workPeriodsByDay = lodash.map(lodash.range(7), function(dayNum) {
              return {
                dt: moment($scope.weekRange.start).add(dayNum, 'days').twix(moment($scope.weekRange.start).add(dayNum + 1, 'days')),
                adt: moment($scope.adjustedWeekRange.start).add(dayNum, 'days').twix(moment($scope.adjustedWeekRange.start).add(dayNum + 1, 'days')),
                label: moment($scope.weekRange.start).add(dayNum, 'days').format('dd'),
                workPeriods: [],
                unavailabilityItems: [],
                numHours: 0
              };
            });
          };

          initializeWeekCalendarData();

          var setWeekCalendarData = function() {
            var thisShiftsDay = null;
            var rawDatesTwix = moment($scope.shift.start_time).twix($scope.shift.end_time);

            initializeWeekCalendarData();
            lodash.each($scope.workPeriodsByDay, function(day, idx) {
              if (day.dt.contains($scope.shift.start_time)) {
                thisShiftsDay = idx;
              }
            });

            //ALWAYS exclude the currentShift from the array of _workPeriods


            if ($scope.emp._workPeriods) {
              lodash.each($scope.workPeriodsByDay, function(day, idx) {
                var workPeriodsToProcess = [];

                if (idx === thisShiftsDay) {
                  //console.log('emp: ', $scope.emp.name);
                  //console.log('unfiltered WorkPeriods', $scope.emp._workPeriods, wpidExclusion);

                  workPeriodsToProcess = lodash.filter($scope.emp._workPeriods, function(wp) {
                    return day.dt.contains(wp.start_time) &&

                      ((lodash.isNull(wpidExclusion) &&
                        (($scope.shift.$isShift() && (($scope.shift._workPeriod && $scope.shift._workPeriod.id !== wp.id) ||
                          (!$scope.shift._workPeriod))) || ($scope.shift.$isWorkPeriod() && $scope.shift.id !== wp.id))) ||
                      (!lodash.isNull(wpidExclusion) && wp.id !== wpidExclusion));
                  });

                  day.workPeriods = lodash.map(workPeriodsToProcess, function(wp) {
                    if (wp.range_twix.overlaps(rawDatesTwix) &&
                        Math.abs(wp.range_twix.intersection(rawDatesTwix).length('minutes')) > 0 &&
                        !wpIsSameAsShiftWp(wp)) {
                      wp._classes = {
                        warning: true
                      };
                    }
                    return wp;
                  });
                } else {
                  day.workPeriods = lodash.filter($scope.emp._workPeriods, function(wp) {
                    wp._classes = {};
                    return day.dt.contains(wp.start_time);
                  });
                  workPeriodsToProcess = day.workPeriods;
                }

                day.numHours = +(lodash.reduce(lodash.map(workPeriodsToProcess, function(wp) {
                  var intersectionLength = Math.abs(wp.range_twix.intersection(day.adt).length('minutes'));
                  if (wp.range_twix.overlaps(day.adt) && intersectionLength > 0) {
                    return intersectionLength / 60.0;
                  } else {
                    return 0;
                  }
                }), function(sum, num) {
                  return sum + num;
                }, 0));

                //if (idx === thisShiftsDay && ($scope.emp._scheduledToWork || !isAssignedToShift())) {
                if (idx === thisShiftsDay) {
                  var intersectionLength = Math.abs($scope.shift.range_twix.intersection(day.adt).length('minutes'));
                  if ($scope.shift.range_twix.overlaps(day.adt) && intersectionLength > 0) {
                    day.numHours += intersectionLength / 60.0;
                  }
                }

                day.numHours = day.numHours.toFixed(2);
              });
            }

            if (!isAssignedToShift() && !lodash.isNull(thisShiftsDay)) {
              //now add the new shift to the appropriate day
              $scope.workPeriodsByDay[thisShiftsDay].workPeriods.push({
                start_time: moment($scope.shift.start_time),
                end_time: moment($scope.shift.end_time),
                _classes: {
                  new: true
                },
                from: {
                  isAssignedToShift: isAssignedToShift()
                }
              });
            }

            if (($scope.emp._scheduledToWork || isAssignedToShift()) && !lodash.isNull(thisShiftsDay)) {
              $scope.workPeriodsByDay[thisShiftsDay].workPeriods.push({
                start_time: moment($scope.shift.start_time),
                end_time: moment($scope.shift.end_time),
                _classes: {
                  editing: true
                },
                from: {
                  _scheduledToWork: $scope.emp._scheduledToWork,
                  isAssignedToShift: isAssignedToShift()
                }
              });
            }
          };

          var setAvailabilityRuleInfo = function() {
            if ($scope.shift.end_time.hour() === 0 &&
                ($scope.shift.start_time.day() === $scope.shift.end_time.day() - 1)) {
              $scope.daysOfWeek = [$scope.shift.start_time.day()];
            } else {
              $scope.daysOfWeek = lodash.uniq([$scope.shift.start_time.day(),$scope.shift.end_time.day()]);
            }

            var effectiveAvailabilitySet = $scope.emp && $scope.emp.availability_sets.length > 0 && lodash.find($scope.emp.availability_sets, function(availSet) {
              return availSet.$isInEffect($scope.shift.start_time) && availSet.$isApproved();
            });

            if(!lodash.isUndefined(effectiveAvailabilitySet) &&
                !lodash.isUndefined(effectiveAvailabilitySet.availability_rules) &&
                effectiveAvailabilitySet.availability_rules.length > 0) {
              $scope.availabilityRulesForDays = lodash.map($scope.daysOfWeek, function(d) {
                return lodash.filter(effectiveAvailabilitySet.availability_rules, function(ar) {
                  return ar.active && ar._type === 'weekly' && ar.day_of_week === d;
                });
              });
            } else {
              $scope.availabilityRulesForDays = [];
              lodash.each($scope.daysOfWeek, function(x) {
                $scope.availabilityRulesForDays.push([]);
              });
            }
          };


          var createTimeText = function(rule) {
            var startTimeHTML = TimeService.minutesToTimeString(rule.start_time_minutes, true);
            var endTimeHTML = TimeService.minutesToTimeString(rule.end_time_minutes, true);

            return startTimeHTML + '-' + endTimeHTML;
          };

          var initCalendarDates = function() {
            $scope.calendarDates = lodash.map(lodash.range(7), function(dayNum) {
              return moment($scope.weekRange.start).add(dayNum, 'days').twix(moment($scope.weekRange.start).add(dayNum + 1, 'days'))
            });
          };

          var initUnavailabilityItems = function(dayIndex) {
            // dayIndex is 0..6 corresponding to array of dates being passed in (scope.calendarDates)
            // look through time_off_rules for a day off here

            // add hours to startDayOfWeek calculation to ensure no TZ/DST issues
            var conditions = {
              startDayOfWeek: moment($scope.calendarDates[dayIndex].start).add(6, 'hours').day(),
              twix: $scope.calendarDates[dayIndex]
            };

            var theTwix = moment(conditions.twix.start).twix(moment(conditions.twix.end));

            var timeOffRules = lodash.filter($scope.emp.time_off_rules, function(rule) {
              return rule.range_twix.overlaps(theTwix) && rule.active && rule.$isApproved();
            });

            if (timeOffRules.length > 0) {
              lodash.each(timeOffRules, function(rule) {
                var intersection = rule.range_twix.intersection(conditions.twix);
                var isAllDay = intersection.equals($scope.calendarDates[dayIndex]);

                // index of workPeriodsByDay is the modified index (Monday may be in 0th position)
                $scope.workPeriodsByDay[dayIndex].unavailabilityItems.push({
                  id: rule.id,
                  reason: rule.comment !== '' ? rule.comment : 'No reason provided',
                  text: isAllDay ? 'All Day' : TimeService.minimalTwixFormat(intersection, true),
                  classes: {
                    dayoff: true,
                    weekly: false,
                    allday: isAllDay
                  }
                });
              });
            }

            var relevantSet = lodash.find($scope.emp.availability_sets, function(availSet) {
              // add 6 hours just in case availabilitySet is changing on dayStartHour (up to 6)
              return availSet.$isInEffect(moment(conditions.twix.start).add(6, 'hours')) && availSet.$isApproved();
            });

            if (relevantSet) {
              var realDayIndex = $scope.dayOfWeekMapping[dayIndex];
              var unavailableRules = lodash.filter(relevantSet.availability_rules, {day_of_week: realDayIndex, avail: false});
              lodash.each(unavailableRules, function(rule) {
                var isAllDay = rule.start_time_minutes === 0 && rule.end_time_minutes === 1440;
                $scope.workPeriodsByDay[dayIndex].unavailabilityItems.push({
                  id: rule.id,
                  reason: rule.messages && !lodash.isUndefined(lodash.last(rule.messages)) ? lodash.last(rule.messages).text : 'No reason provided',
                  text: isAllDay ? 'All Day' : createTimeText(rule),
                  classes: {
                    dayoff: false,
                    weekly: true,
                    allday: isAllDay
                  }
                });
              });
            }
          };

          // Create mapping for typical dayOfWeek mapping Sunday=0..Saturday=6 to their store's map
          $scope.dayOfWeekMapping = {};
          var tempDayIndex = $scope.adjustedWeekRange.start.day();
          lodash.each(lodash.range(7), function(dayNum) {
            $scope.dayOfWeekMapping[dayNum] = tempDayIndex;
            if (tempDayIndex === 6) {
              tempDayIndex = 0;
            } else {
              tempDayIndex = tempDayIndex + 1;
            }
          });

          $scope.$watch('[shift.start_time._d, shift.end_time._d]', function() {
            if (!lodash.isUndefined($scope.shift)) {
              setAvailabilityRuleInfo();
              $scope.lengthOfShiftInHours = ($scope.shift.range_twix.length('minutes') / 60.0);

              if ($scope.emp) {
                setWeekCalendarData();
              }
              initCalendarDates();
            }
          }, true);


          $scope.$on('sa:employeeSelectedForInfo', function(event, emp) {
            console.log('sa:employeeSelectedForInfo', emp.name);
            $scope.state.stillCalculating = true;
            $scope.emp = emp;
            setAvailabilityRuleInfo();
            setWeekCalendarData();
            initCalendarDates();
            lodash.each(lodash.range(7), function(dayNum) {
              initUnavailabilityItems(dayNum);
            });
            $scope.state.isAssignedToShift = isAssignedToShift();
            //$log.log('isAssignedToShift: ', $scope.state.isAssignedToShift, $scope.emp.name, $scope.emp._hoursThisWeek);
            $scope.lengthOfShiftInHours = ($scope.shift.range_twix.length('minutes') / 60.0);
            $scope.numHoursThisWeek = $scope.emp._hoursThisWeek +
                ($scope.state.isAssignedToShift ? $scope.lengthOfShiftInHours : 0);
            $scope.state.stillCalculating = false;
            $scope.effectiveAvailabilitySet = $scope.emp.$effectiveAvailabilitySet($scope.shift.start_time);
          });

          $scope.$on('sa:cwpLoadFinished', function(event, emp) {
            if (emp === false) {
              $scope.state.stillCalculating = true;
              $scope.emp = undefined;
              $scope.topRecommendation = undefined;
            } else if (lodash.isUndefined(emp)) {
              $scope.state.stillCalculating = false;
              $scope.emp = undefined;
              $scope.topRecommendation = undefined;
            } else {
              $scope.state.stillCalculating = false;
              $scope.emp = emp;
              //$log.log('TIME: ', (moment.utc().valueOf() - window.baseTime), 'cwpLoadFinished w/ emp', $scope.emp.id);
              setAvailabilityRuleInfo();
              setWeekCalendarData();
              initCalendarDates();
              lodash.each(lodash.range(7), function(dayNum) {
                initUnavailabilityItems(dayNum);
              });
              $scope.state.isAssignedToShift = isAssignedToShift();
              $scope.lengthOfShiftInHours = ($scope.shift.range_twix.length('minutes') / 60.0);
              //$log.log('isAssignedToShift: ', $scope.state.isAssignedToShift, $scope.emp.name, $scope.emp._hoursThisWeek);
              $scope.numHoursThisWeek = $scope.emp._hoursThisWeek +
                  ($scope.state.isAssignedToShift ? $scope.lengthOfShiftInHours : 0);
              $scope.effectiveAvailabilitySet = $scope.emp.$effectiveAvailabilitySet($scope.shift.start_time);
            }
            $scope.topRecommendation = emp;
          });

          // let parent controller know that we've loaded and are ready to process cwpLoadFinished commands
          $scope.$emit('sa:userRecommendBar:controllerInitCompleted');
        }]
      };
    });
